import React, {memo, Fragment, useContext} from 'react'
import LogoDark from '../../assets/images/logo-dark.png'
import LogoLight from '../../assets/images/logo-light.png'
import { SettingsContext } from '../../context/settings-context'

const Logo = memo((props) => {
    const { theme } = useContext(SettingsContext)

    return (
        <Fragment>
            <img src={theme === 'dark' ? LogoDark : LogoLight} className="tw:h-[30px] tw:w-auto" alt="Turba Media"/>
        </Fragment>
    );
});

Logo.displayName = 'Logo'
export default Logo;
